
import { Component, Vue } from "vue-property-decorator"
import { Getter, Action } from "vuex-class"

import SignUpForm from "@/types/signupForm"

import api from "@/services/api"
import { LoginRequest } from "@/types"

import PasswordInput from "@/components/Controls/PasswordInput.vue"

@Component({
	components: {
		"password-input": PasswordInput
	}
})
export default class SignUp extends Vue {
	@Action public logIn!: (login: LoginRequest) => void;

	@Getter("getScreenWidth")
	public screenWidth!: number;

	public passwordScore: number | null = null

	public signUp: SignUpForm = {
		tenantName: "",
		name: "",
		email: "",
		password: "",
		passwordConfirmation: ""
	};

	validationMessage: string = ""
	private creatingAccount: boolean = false;
	passwordValid: boolean = false;

	// TODO replace with vuelidate so feedback does not appear instantly
	get isValid () {
		this.validationMessage = ""
		if (!this.passwordValid || !this.passwordScore || this.passwordScore < 3) {
			return false
		}

		if (this.signUp.password !== this.signUp.passwordConfirmation) {
			this.validationMessage = "Passwords do not match"
			return false
		}

		for (let [key, value] of Object.entries(this.signUp)) {
			if (!value) {
				this.validationMessage = `${key} required`
				return false
			}
		}

		return true
	}

	private async createAccount () {
		this.creatingAccount = true
		try {
			await api.createAccount(this.signUp)
			await this.logIn({
				email: this.signUp.email,
				password: this.signUp.password
			})
			this.$router.push({ path: "login" })
		} catch (err) {
			this.validationMessage = err
		}
		setTimeout(() => this.creatingAccount = false, 750)
	}

	private updatePasswordScore (score: number) {
		this.passwordScore = score
	}

	private updatePasswordValid (valid: boolean) {
		this.passwordValid = valid
	}

	private redirectToLogin () {
		this.$router.push({ path: "login" })
	}
}
